export const windowHasFocusSelector = (state) => state.get('window').get('hasFocus');
